import { normalHex, shortHex } from '@trx/shared';

export const getObjectValueByStringPath = (
  obj: object,
  stringObjPath: string,
) => {
  const fields = stringObjPath.split('.');
  const prepareObjValue = (obj: object, fields: string[], idx = 0) => {
    if (idx < fields.length - 1 && obj?.[fields[idx]]) {
      const newIdx = idx + 1;
      return prepareObjValue(obj[fields[idx]], fields, newIdx);
    }
    return obj[fields[idx]];
  };
  return prepareObjValue(obj, fields);
};

export const getButtonColorUtil = (hex?: string) => {
  if (!hex) {
    return 'black';
  }

  const rgbChar = ['r', 'g', 'b'];

  const rgbObj = { r: 255, g: 255, b: 255 };

  const normal = hex.match(normalHex);
  const shorthand = hex.match(shortHex);

  if (normal) {
    normal.slice(1).forEach((el, i) => {
      rgbObj[rgbChar[i]] = parseInt(el, 16);
    });
  } else if (shorthand) {
    shorthand.slice(1).forEach((el, i) => {
      rgbObj[rgbChar[i]] = 0x11 * parseInt(el, 16);
    });
  }

  if (rgbObj.r + rgbObj.g + rgbObj.b > 383) {
    return 'black';
  } else {
    return 'white';
  }
};
